var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-page',{attrs:{"illustration":"/img/not-found-page.svg","illustration-alt":"Illustration of a missing page with a question mark","code":"404 · Not found","title":"Page not found","message":"This page doesn't exist or was removed."}})
}
var staticRenderFns = []

export { render, staticRenderFns }